import React from 'react';
import i18next from 'core/i18n';
import { SmallBody } from '@indigo-ag/component-module';

import { Card, TimelineEventsProps, TimelineEvents, utils } from 'shared';

export interface TimelineEventsCardProps extends TimelineEventsProps {
  maxHeight?: string;
}

export const TimelineEventsCard: React.FunctionComponent<TimelineEventsCardProps> = ({
  maxHeight = '50vh',
  ...timelineEventsProps
}) => {
  return (
    <Card title={i18next.t('timeline')}>
      <div style={{ overflowY: 'auto', height: maxHeight }}>
        {timelineEventsProps.events.length ? (
          <TimelineEvents {...timelineEventsProps} />
        ) : (
          <SmallBody>{utils.text.firstLetterUppercase(i18next.t('noEventsYet'))}</SmallBody>
        )}
      </div>
    </Card>
  );
};
